import { render, staticRenderFns } from "./TitleDetails.vue?vue&type=template&id=397e1a04&"
import script from "./TitleDetails.vue?vue&type=script&lang=js&"
export * from "./TitleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports